import { configureStore } from '@reduxjs/toolkit';

import priceMatrixApp from '../reducers/priceMatrix';

// `common` is the host-page state object seeded through `preloadedState`. `devTools` is dev-only;
// dev checks stay on.
export const createPriceMatrixStore = (common) =>
  configureStore({
    reducer: priceMatrixApp,
    preloadedState: { common },
    devTools: process.env.NODE_ENV !== 'production',
  });
